export default {
    en: {
        number: 12,
        diagramId: 11,
        answers: 'economic linkages connections generate tensions, new tensions',
        interactiveBoxNumber: [1, 2],
        blocks:
            [
                {
                    task: {
                        question: 'Global oil and gas markets are part of a dense network of economic linkages and connections',
                        answer: '<span class="correct-answer-box">Global oil and gas markets are part of a dense network of <span class="highlight__answer highlight__answer_correct">economic linkages</span> and connections</span>'
                    },
                    example: true
                },
                {
                    task: {
                        question: 'These connections generate tensions, particularly around trade and currencies',
                        answer: '<span class="correct-answer-box">These <span class="highlight__answer highlight__answer_correct">connections generate tensions,</span> particularly around trade and currencies</span>'
                    },
                    selectAvailable: true
                },
                {
                    task: {
                        question: 'China’s growth will bring about a new balance in the market, generating new tensions',
                        answer: '<span class="correct-answer-box">China’s growth will bring about a new balance in the market, generating <span class="highlight__answer highlight__answer_correct">new tensions</span></span>'
                    },
                    selectAvailable: true
                },
                {
                    task: {
                        question: 'Important not to recast normal petro rivalry into a contest of nation states',
                        answer: '<span class="correct-answer-box">Important not to recast normal petro rivalry into a contest of nation states</span>'
                    }
                }
            ]
    }
};



// WEBPACK FOOTER //
// ./client/app/modules/courses/3/3a1/deductiveReasoning/i18n/exercise12.js